import {observable, action} from 'mobx'
import {json, get} from "../../../utils/ajax";
import {setStore, formatParams, ValueObjToObj, handleSearchAndPage} from "../../../utils/Utils";
import {runInAction} from "mobx/lib/mobx";
import {message} from "antd";
import moment from "moment";

class OverseasCustomizationStore {

    @observable loading
    @observable overSeaCarService //海外车系
    @observable formatMessage //国际化
    @observable index //新闻弹框内容
    @observable oneLevelMenu //一级目录的数据
    @observable oneMenu //当前选择的一级目录
    @observable twoLeveLoading //二级目录加载数据
    @observable twoLevelMenu //二级目录的数据
    @observable expandedLeftRowKeys //二级目录展开的行变化时触发
    @observable twoMenu //三级目录的数据
    @observable threeLeveLoading //三级目录的数据
    @observable selectThreeMenu //选择的三级目录
    @observable threeLevelMenuClickRow //三级目录点击行的数据
    @observable result //四级目录的数据
    @observable resultLoading //四级目录加载数据
    @observable selectFourMenu //点击的四级目录
    @observable allHotList //所有热点列表，用来回显
    @observable leftHeight //左边内容的高度
    @observable rightHeight //右边内容的高度
    @observable pictureHeight //中间内容的高度
    @observable photos //图片
    @observable addHotList //前台热点回显
    @observable hotGrade //表格回显热点标号
    @observable searchValue //搜索框的值
    @observable shoppingModel //购物车模块
    @observable editField //购物车
    @observable shoppingRowData //点击行数据
    @observable showSixPhotos //备件信息图片模态框
    @observable selectResult //选中右侧的表格项
    @observable showPhoto //显示大图的模态框
    @observable selectPhoto //当前显示的大图
    @observable showReplace //显示替换模态框
    @observable rightUpperTableClickRow //四级目录点击行的数据
    @observable searchListModalVisible //备件详情模态框
    @observable sparePartNumberLoading //点击备件出来数据的加载
    @observable sparePartNumberModalVisible //控制点击右侧备件隐藏和显示
    @observable sparePartNumberList //存放备件详情信息
    @observable searchLoading //搜索出来数据的加载
    @observable searchList //搜索出来的数据
    @observable vinSearchData //输入的Vin
    @observable overseasShoppingCartList //购物车列表
    @observable pagination //购物车分页
    @observable searchFields //购物车搜索存值
    @observable selectedRowKeysId
    @observable gradeVal //数量改变时的值
    @observable gradeValIndex
    @observable userInfo
    @observable stationType

    constructor() {
        this.loading = false
        this.overSeaCarService = []
        this.formatMessage = () => {
        }
        this.index = []
        this.oneLevelMenu = []
        this.oneMenu = ''
        this.twoLeveLoading = false
        this.twoLevelMenu = []
        this.expandedLeftRowKeys = []
        this.twoMenu = []
        this.threeLeveLoading = false
        this.selectThreeMenu = ''
        this.resultLoading = false
        this.result = []
        this.allHotList = []
        this.leftHeight = 0
        this.rightHeight = 0
        this.pictureHeight = 0
        this.photos = []
        this.threeLevelMenuClickRow = {}
        this.addHotList = []
        this.selectFourMenu = ''
        this.hotGrade = ''
        this.searchValue = ''
        this.shoppingModel = false
        this.editField = {}
        this.shoppingRowData = {}
        this.showSixPhotos = false
        this.selectResult = {}
        this.showPhoto = false
        this.selectPhoto = ''
        this.showReplace = false
        this.rightUpperTableClickRow = {}
        this.searchListModalVisible = false
        this.sparePartNumberLoading = false
        this.sparePartNumberModalVisible = false
        this.sparePartNumberList = []
        this.searchLoading = false
        this.searchList = []
        this.vinSearchData = ''
        this.overseasShoppingCartList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {
            spareNo: '',
            materialNo: '',
            time: ''
        }
        this.selectedRowKeysId = []
        this.gradeVal = ''
        this.gradeValIndex = ''
        this.userInfo = {user: {}, company: {}}
        this.stationType=''
    }

    /** 设置store对象，类似react的setState **/
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /** 海外车系页面初始化 **/
    @action
    initOverSeaCarService = async () => {
        this.loading = true
        const res1 = await get(`${process.env.REACT_APP_API_URL}/userInfo`)
        if (res1.status) {
            runInAction(() => {
                this.userInfo = res1.data
                // this.numberOfReplies = res1
            })
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryOverseasModels?vin=${this.vinSearchData}`)
        runInAction(() => {
            this.overSeaCarService = Array.isArray(res) ? res : []
            this.loading = false
        })
        if (this.overSeaCarService.length === 0) {
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseCheckTheVinCodeInTheDomesticCarSeries'}))
        }
    }

    /** 索引 **/
    @action
    initIndex = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/frontdesk`)
        runInAction(() => {
            this.index = Array.isArray(res) ? res : []
        })
    }

    /** 获取url中的参数并转化为对象 **/
    @action
    getUrlParmas(str) {
        let obj = {}
        str.substring(1).split('&').forEach(item => {
            const arr = item.split('=')
            obj[arr[0]] = decodeURI(arr[1])
        })
        return obj
    }

    /** 获取一级目录的数据 **/
    @action
    catalogueIData = async () => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let obj = {...paramsObj}
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryNineCategories`, formatParams(obj))
        runInAction(() => {
            this.oneLevelMenu = Array.isArray(res) ? res : []
            //获取二级目录
            const id = this.oneLevelMenu[0] ? this.oneLevelMenu[0].id : ''
            const path = this.oneLevelMenu[0] ? this.oneLevelMenu[0].path : ''
            const code = this.oneLevelMenu[0] ? this.oneLevelMenu[0].code : ''
            this.selectOneMenuData(path, id, code)
        })
    }

    /** 通过点击一级目录获取二级目录的数据 **/
    @action
    selectOneMenuData = async (path, id, code) => {
        this.twoLeveLoading = true
        this.result = []
        this.selectThreeMenu = ''
        this.hotGrade = ''
        this.twoMenu = []
        this.addHotList = []
        this.selectFourMenu = ''
        this.oneMenu = path
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = {}
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {...paramsObj}
        let nineId = id
        if (!nineId) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    nineId = item.id
                    break
                }
            }
        }
        let obj = {
            [`search.carseriesCode`]: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            [`search.nineId`]: nineId,
            [`search.nineCode`]: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...formatParams(data)
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryTwoCatalogsByNineCategorieI`, obj)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryMainQroup`, obj)
        await this.getPhotoList(nineId, code, paramsObj)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
    }

    /** 展开的行变化时触发 **/
    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    /** 二级目录的点击事件 **/
    @action
    twoLevelMenuClick = async (record, index) => {
        this.addHotList = []
        this.result = []
        this.hotGrade = ''
        this.selectFourMenu = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        await this.getThreeLevelMenu(record)
    }

    /** 通过点击二级目录获取三级目录的数据 **/
    @action
    getThreeLevelMenu = async (record) => {
        this.threeLeveLoading = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let obj = {
            ...paramsObj,
            carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            twoCatalohId: record.id,
            twoCatalohCode: record.code
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryThreeCatalogsByTwoCategorieId`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINLookupQroup`, formatParams(obj))
        runInAction(() => {
            this.twoMenu = Array.isArray(res) ? res : []
            this.threeLeveLoading = false
            this.photos = this.twoMenu.length > 0 && this.twoMenu
            this.selectThreeMenu = this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.photos[0].path
            this.twoMenu.length > 0 && this.twoMenu.length <= 1 && this.threeLevelMenuClick(this.photos[0])
        })
    }

    /** 三级目录的点击事件 **/
    @action
    threeLevelMenuClick = async (record) => {
        this.resultLoading = true
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = record
        this.addHotList = []
        this.hotGrade = ''
        this.selectThreeMenu = record.path
        this.photos = [record.imgUrl || '']
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {...paramsObj}
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/querySparePartsByThreeCategorieId`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/checkTheVehicleSeriesVINForSpareParts`, {
            [`search.threeCatalohId`]: record.id,
            [`search.carseriesCode`]: record.carseriesCode,
            ...formatParams(data)
        })
        runInAction(() => {
            this.result = Array.isArray(res) ? res : []
            this.resultLoading = false
            this.allHotList = this.result.reduce((acc, cur) => {
                let list = Array.isArray(cur.coordinateList) ? cur.coordinateList.map(item => {
                    return {...item, grade: cur.grade}
                }) : []
                return acc.concat(list)
            }, [])
        })
    }

    /** 图片数据 **/
    @action
    getPhotoList = async (id, code, paramsObj) => {
        const search = window.location.search
        const paramsObj1 = this.getUrlParmas(search)
        let condition = paramsObj || paramsObj1
        const obj = {
            carseriesCode: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            nineId: id,
            nineCode: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...condition,
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryPhotos`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryQroupPictures`, formatParams(obj))
        runInAction(() => {
            this.photos = Array.isArray(res) ? res : []
        })
    }

    /** 点击图片时定位到二级目录上 **/
    @action
    twoLocation = (item) => {
        const path = item.figureNo.split('-')[0]
        let record = {}
        let index = 0
        this.twoLevelMenu.find((v, i) => {    //用find只是可以提前打断遍历
            this.expandedLeftRowKeys = [v.path]
            const same = v.path.split('/').pop() === path
            if (same) {
                record = v
                index = i
            }
            return same
        })
        this.twoLevelMenuClick(record, index)
    }

    /** 热点定位 **/
    @action
    editPosHot = (hot) => {
        this.addHotList = [hot]
        this.selectFourMenu = ''
        this.hotGrade = hot.grade
    }

    /** 获取到input输入的值 **/
    @action
    searchValueClickData = (value) => {
        this.searchValue = value
    }

    /** 购物车 **/
    @action
    changedField = (changedFields) => {
        this.editField = {...this.editField, ...ValueObjToObj(changedFields)}
    }

    /** 点击购物车 **/
    @action
    clickShoppingData = async (record) => {
        this.shoppingModel = true
        this.shoppingRowData = record
        this.editField = {}
    }

    /** 添加购物车 **/
    @action
    addShoppingData = async () => {
        this.shoppingModel = false
        let data = {
            serviceCodeList: [],
            materialNo: this.shoppingRowData.materialNo ? this.shoppingRowData.materialNo : '',
            spareName: this.shoppingRowData.spareName ? this.shoppingRowData.spareName : '',
            spareNo: this.shoppingRowData.spareNo ? this.shoppingRowData.spareNo : '',
            orderNumber: this.editField.orderNumber
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasShoppingCart/insert`, data)
        if (res.status) {
            message.success(this.formatMessage({id: 'ConfigureQuery.success'}))
        } else {
            message.warning(this.formatMessage({id: 'ConfigureQuery.warning'}))
        }
        runInAction(() => {
            this.editField = {}
        })
    }

    /** 查询图片信息 **/
    @action
    getPhotoData = async (record, e) => {
        this.showSixPhotos = true
        this.selectResult = record
    }

    /** 查询替换信息 **/
    @action
    editGetReplaceInfo = async (record, e) => {
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        const obj = {
            [`search.bySpareNo`]: record.spareNo,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.catalogId`]: this.threeId
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/getChangeInfoByMaterialNo`, obj)
        runInAction(() => {
            this.replaceDetail = Array.isArray(res) ? res : []
            this.showReplace = true
        })
    }

    /** 右下表格的点击事件 **/
    @action
    rightUpperTableClick = async (record) => {
        this.threeLevelMenuClickRow = {}
        this.rightUpperTableClickRow = record
        this.addHotList = record && record.coordinateList
        this.selectFourMenu = record.id
        this.hotGrade = ''
        this.searchListModalVisible = false
    }

    /** 点击备件查询详情 **/
    @action
    sparePartNumber = async (record) => {
        this.sparePartNumberLoading = true
        this.sparePartNumberModalVisible = true
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/queryDetailedInformationBasedOnSpareParts/carseriesCode`, {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/verification/checkTheDetailedInformationOfTheSparePartNumber`, {
            [`search.lv3Id`]: record.catalogId,
            [`search.carseriesCode`]: paramsObj.carseriesCode,
            [`search.vin`]: paramsObj.vin,
            [`search.grade`]: record.grade
        })
        runInAction(() => {
            this.sparePartNumberList = Array.isArray(res) ? res : []
            this.sparePartNumberLoading = false
        })
    }

    /** 点击下面的表格 **/
    @action
    clickTheTableBelow = async (record) => {
        this.selectFourMenu = record.id
    }

    /** 查询 **/
    @action
    searchValueData = async () => {
        if (!this.searchValue) {
            message.warning(this.formatMessage({id: 'ConfigureQuery.PleaseEnterTheSearchCriteria'}))
            return
        }
        this.searchLoading = true
        this.searchListModalVisible = true
        this.sparePartNumberModalVisible = false
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {...paramsObj}
        let obj = {content: this.searchValue, ...data}
        if (paramsObj.carseriesId) {
            obj.carseries = paramsObj.carseriesId
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/querySparePartsByContent`, formatParams(obj))
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/frontDeskInquiry`, formatParams(obj))
        runInAction(() => {
            this.searchList = Array.isArray(res) ? res : []
            this.searchLoading = false
        })
    }

    /** 点击零件定位到指定的目录去 **/
    @action
    locationData = async (record) => {
        const paths = record.path.split('/')
        const oneMenu = `/${paths[1]}`
        const twoMenu = `${oneMenu}/${paths[2]}`
        const threeMenu = record.path
        const code1 = `${paths[1]}`
        const code2 = `${paths[2]}`
        const code3 = `${paths[3]}`
        //如果当前就是要定位的三级目录则return
        this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode(record.carseriesCode, code1)
        await this.queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji(record.carseriesCode, code3)
        await this.changeExpandedLeftRowKeys2(record)
        this.expandedLeftRowKeys = [twoMenu, threeMenu]
        this.addHotList = record && record.coordinateList
        return
    }

    /** 根据车系code和目录code查询1级目录 **/
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode2?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.selectOneMenuData2(res.path, res.id, res.code)
        })
    }

    /** 通过点击一级目录获取二级目录的数据 **/
    @action
    selectOneMenuData2 = async (path, id, code) => {
        this.twoMenu = []
        this.result = []
        this.addHotList = []
        this.hotGrade = ''
        this.rightUpperTableClickRow = {}
        this.threeLevelMenuClickRow = {}
        this.twoLeveLoading = true
        this.oneMenu = path
        const search = window.location.search
        const paramsObj = this.getUrlParmas(search)
        let data = {...paramsObj}
        let nineId = id
        if (!nineId) {
            for (let item of this.oneLevelMenu) {
                if (item.path === path) {
                    nineId = item.id
                    break
                }
            }
        }
        let obj = {
            [`search.carseriesCode`]: this.oneLevelMenu[0] ? this.oneLevelMenu[0].carseriesCode : '',
            [`search.nineId`]: nineId,
            [`search.nineCode`]: code !== undefined ? code : this.oneLevelMenu[0].code,
            ...formatParams(data)
        }
        // const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/queryTwoCatalogsByNineCategorieI`, obj)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/frontDesk/vehicleSeriesVINQueryMainQroup`, obj)
        runInAction(() => {
            this.twoLevelMenu = Array.isArray(res) ? res : []
            this.twoLeveLoading = false
        })
    }

    /** 根据车系code和目录code查询3级目录 **/
    @action
    queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode3ji = async (carseriesCode, code) => {
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalog/queryTheFirstLevelCatalogAccordingToTheCarCodeAndCatalogCode?carCode=${carseriesCode}&code=${code}`)
        runInAction(() => {
            this.loading = false
            this.threeLevelMenuClick(res)
        })
    }

    /** 展开的行变化时触发 **/
    @action
    changeExpandedLeftRowKeys2 = (record) => {
        this.selectFourMenu = record.id
    }

    /** 购物车页面初始化 **/
    @action
    shoppingCartInitPage = async (page) => {
        this.loading = true
        let search = handleSearchAndPage(page, this.pagination, this.searchFields);
        search[`search.beginTime`] = this.searchFields.time.length > 0 ? moment(this.searchFields.time[0]).format("YYYY-MM-DD") : '';
        search[`search.endTime`] = this.searchFields.time.length > 0 ? moment(this.searchFields.time[1]).format("YYYY-MM-DD") : '';
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasShoppingCart/overseasShoppingCartPage`, search);
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.overseasShoppingCartList = res.content || []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.gradeValIndex = ''
            this.loading = false
        })
    }


    /** 购物车页面初始化 **/
    @action
    getPushStatus = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/servicestation/determineTheCartPushButton`);
           runInAction(() => {
               this.stationType=res.stationType
           })

    }

    /** 购物车将页面的值绑到store **/
    @action
    onFieldsChange = (changedFields) => {
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /** 购物车重置表单 **/
    @action
    clearSearch = async () => {
        this.searchFields = {
            spareNo: '',
            materialNo: '',
            time: ''
        }
        await this.shoppingCartInitPage()
    }

    /** 购物车选中行的id **/
    @action
    selectedRowKeys = (selectedRowKeys) => {
        this.selectedRowKeysId = selectedRowKeys
    }

    /** 购物车批量删除 **/
    @action
    editPlaceOrder = async () => {
        this.loading = true
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasShoppingCart/batchDel`, this.selectedRowKeysId)
        await this.shoppingCartInitPage()
        runInAction(() => {
            this.loading = false
        })
    }

    /** 购物车删除 **/
    @action
    deleteData = async (id) => {
        let ids = [id]
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasShoppingCart/batchDel`, ids)
        await this.shoppingCartInitPage()
    }

    /** 购物车修改数量 **/
    @action
    onBlurGradeData = async (value, record) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasShoppingCart/updateCount/${record.id}/${value}`)
        if (res.status) {
            message.success(`修改成功！`)
        } else {
            message.error(`修改失败！`)
        }
        await this.shoppingCartInitPage(this.pagination.current)
    }

    /** 推送备件 **/
    @action
    pushSpareParts = async () => {
        if(!this.selectedRowKeysId.length){
            message.warning(this.formatMessage({id: 'shopping.msg'}))
            return
        }
        this.loading = true
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/overseasDMSDocking/cartPushSpareParts?ids=${this.selectedRowKeysId}`)
        if (res.result === "1") {
            message.success(this.formatMessage({id: 'ConfigureQuery.success'}))
        } else {
            message.warning(this.formatMessage({id: 'ConfigureQuery.warning'}))
        }
        runInAction(() => {
            this.loading = false
        })
        await this.shoppingCartInitPage()
    }

}

export default new OverseasCustomizationStore()



// WEBPACK FOOTER //
// ./src/project/frontZCYS/OverseasCustomization/store.js